/* @flow */
import Entity from 'lib/Entity';

export default class StripeBankAccount extends Entity {
  getBankName(): ?string {
    return this.get('bank_name');
  }

  isDefaultForCurrency(): boolean {
    return this.get('default_for_currency');
  }

  setDefaultForCurrency(value: boolean) {
    return this.set('default_for_currency', value);
  }

  getAccountNumberLastFourDigits(): string {
    return this.get('last4');
  }

  getFingerprint(): string {
    return this.get('fingerprint');
  }

  getAccountHolderName(): string {
    return this.get('account_holder_name');
  }

  getStatus(): string {
    return this.get('status');
  }

  getRoutingNumber(): string {
    return this.get('routing_number');
  }

  getIsDeleted(): boolean {
    return this.get('deleted');
  }
}



// WEBPACK FOOTER //
// ./src/entities/StripeBankAccount.js